export default {
  methods: {
    loadFileInfos(tab, fileId, token) {
      return this.$axios.api.get('sas-telemarketing/file-infos/', {
        params: { tab, fileId, token }
      })
    },

    sendProcessPayment(tab, fileId, token, montant, paymentToken, paymentMethod) {
      const payload = {
        tab,
        fileId,
        token,
        montant,
        paymentToken,
        paymentMethod
      }
      return this.$axios.api.post('sas-telemarketing/complete-payment/', payload)
    }
  }
}
